import { isTypeOfBool } from '../type/type';

export const not = (x: any) => !x;
export const notEqualTo = (x: any) => (y: any) => x !== y;
export const equalTo = (x: any) => (y: any) => x === y;
export const hasVal = (x: any) => !!x;
export const isBetween = (min: number, max: number) => (x: number) => x >= min && x <= max;
export const isGT = (min: number) => (x: number) => x > min;
export const isGTE = (min: number) => (x: number) => x >= min;
export const isLT = (max: number) => (x: number) => x < max;
export const isLTE = (max: number) => (x: number) => x <= max;
export const convertBooleanToInt = (val: any) => (isTypeOfBool(val) ? Number(val) : val);

/* x: (Object | Array) => boolean */
// export const isEmpty = (x: any) =>
//     Array.isArray(x) ? Array.length === 0 : Object.keys(x).length === 0;
